<script setup>
/**
 * Card for displaying a role on the OrganizationRolesAdminPage.
 */

import router from '@/router/router'

const props = defineProps({
	role_id: { type: Number, required: true },
	label : { type: String, required: true },
	description: { type: String, required: true },
})

function onclick()
{
	router.push({
		name: 'admin.organizations.roles.edit',
		state: { role_id: props.role_id },
	})
}
</script>

<template>
<div class="cursor-pointer flex flex-col items-start gap-3 w-70 min-h-45 p-4 justify-between
	rounded-lg border border-t-[.25rem] border-primary-darker
	group hover:border-primary-subtle-hover" @click.prevent="onclick()">
	<div class="flex flex-col items-start">
		<div class="h-6 text-sm font-semibold text-primary-dark bg-primary-lightest rounded
			px-1 py-[2px] justify-center items-center gap-2">{{ label }}</div>
		<div class="mt-3 text-grayscale-body text-sm">{{ description }}</div>
	</div>

	<div class="mt-3">
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"  class="size-5 rotate-180 group-hover:text-primary-hover">
			<path d="M21 11.175H4.98748L11.3625 4.6875C11.7 4.35 11.7 3.825 11.3625 3.4875C11.025 3.15 10.5 3.15 10.1625 3.4875L2.39998 11.3625C2.06248 11.7 2.06248 12.225 2.39998 12.5625L10.1625 20.4375C10.3125 20.5875 10.5375 20.7 10.7625 20.7C10.9875 20.7 11.175 20.625 11.3625 20.475C11.7 20.1375 11.7 19.6125 11.3625 19.275L5.02498 12.8625H21C21.45 12.8625 21.825 12.4875 21.825 12.0375C21.825 11.55 21.45 11.175 21 11.175Z" fill="currentColor"/>
		</svg>
	</div>
</div>
</template>

<style scoped>

</style>